import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getDDProductsToMapStart,
  getDDProductsToMapSuccess,
  getDDProductsToMapFailed
} from 'redux/actions/dataDictionary';
import {
  saveDataMappingRequestSkuEmailDataStart,
  saveDataMappingRequestSkuEmailDataSuccess,
  saveDataMappingRequestSkuEmailDataFailed
} from 'redux/actions/email';


const dataDictionaryApi = `${shopManagerApi}/data-dictionary`;

export const getDDProductsToMapByChargeNameApi = async ({
  dispatch,
  sort,
  filters,
  currentPage,
  rowsPerPage
}) => {
  try {
    dispatch(getDDProductsToMapStart());
    const sortParams = `sortBy[${sort.fieldName}]=${sort.sortDirection}`;
    const filterParams = new URLSearchParams(filters).toString();

    const params = `${sortParams}&${filterParams}&page=${currentPage}&itemsPerPage=${rowsPerPage}`;
    const { data } = await api.get(`${dataDictionaryApi}/api/mapped_products?${params}`);
    dispatch(getDDProductsToMapSuccess(data));
  } catch (e) {
    dispatch(getDDProductsToMapFailed(e));
  }
};

export const saveDataMappingRequestSkuEmailDataApi = async ({dispatch, requestData}) => {
  try {
    dispatch(saveDataMappingRequestSkuEmailDataStart());
    const { data } = await api.post(`${shopManagerApi}/data-mapping/sku-request`, requestData);
    dispatch(saveDataMappingRequestSkuEmailDataSuccess(data));
  } catch (e) {
    dispatch(saveDataMappingRequestSkuEmailDataFailed(e));
  }
};
